import React from 'react';
import getConfig from 'next/config';

const config = getConfig().publicRuntimeConfig;

const JoinMissionPanel = () => {
	return (
		<div style={{ marginTop: '2rem' }}>
			<div className="text-center hide-for-mobile">
				<img
					className=""
					style={{ width: '65%' }}
					loading="lazy"
					src={`${config.cdnUrl}/static/images/home/homev2/brush-desktop-group-image.jpg`}
					alt="Desktop"
				/>
			</div>
			<div className="text-center hide-for-desktop ">
				<img
					className=""
					style={{ width: '90%' }}
					loading="lazy"
					src={`${config.cdnUrl}/static/images/home/homev2/join-our-mission-mobile.jpg`}
					alt="Mobile"
				/>
			</div>
		</div>
	);
};

export default JoinMissionPanel;
